'use client'

import { FC } from 'react'

import ArrowBackIcon from '@/ui-cvi/components/dxp-icons/system/ArrowBackIcon'

import { TClient } from '../shared/resourceClientText'
import { Step, StepType } from './steps'

interface Props {
  pageStep: StepType
  index: number
  onBackClicked: () => void
  setShowSummary: (show: boolean) => void
  steps: Step[]
}

export const TabletAndMobileStepperHeader: FC<Props> = ({ index, onBackClicked, pageStep, setShowSummary, steps }) => {
  let resourceKey = `${pageStep}-PAGE`
  if (pageStep === 'REVIEW') resourceKey = 'REVIEW-AND-PAY-PAGE'
  return (
    <section className="bg-semantic-global-primary-darkest z-10 w-full lg:hidden">
      <div className="p-primitive-16 flex flex-row items-center lg:px-0">
        <div className="text-semantic-global-text-lightest flex flex-1 flex-col">
          <div className="flex flex-1 flex-row items-center">
            {index && steps ? (
              <div className="typography-body-md-regular" onClick={() => setShowSummary(true)}>
                <span>
                  {index + 1} of {steps.length}
                </span>
              </div>
            ) : null}
            {pageStep !== 'CONFIRMATION' ? (
              <div
                className="gap-primitive-4 text-semantic-global-text-lightest ml-auto flex flex-row items-center"
                data-e2e-role="step-back-mobile"
                onClick={onBackClicked}
              >
                <ArrowBackIcon size="lg" />
                <span className="typography-body-md-medium">
                  {pageStep === 'DEPARTURES' ? <TClient text="LEAVE-BOOKING-LAYOUT" /> : <TClient text="BACK" />}
                </span>
              </div>
            ) : null}
          </div>
          <div className="typography-heading-xl flex min-h-14 items-center">
            <TClient text={resourceKey} />
          </div>
        </div>
      </div>
    </section>
  )
}
